import create from 'zustand';

import { LayoutThreeState, ParticipantsByZcta } from '../types';
import { PillIds } from '../components/ParticipantRecluitment/shared/types/PillIds';
import { HhcParticipantData } from '../components/ParticipantRecluitment/shared/types/HhcParticipantData.types';

const useLayoutThreeStore = create<LayoutThreeState>((set) => ({
  chartMode: PillIds.CONSENTED,
  isError: false,
  isLoading: false,
  isSuccess: false,
  mapData: undefined,
  data: undefined,
  setChartMode: (chartMode: PillIds) => {
    set(() => {
      return {
        chartMode,
      };
    });
  },
  setIsError: (isError: boolean) => {
    set(() => {
      return {
        isError,
      };
    });
  },
  setIsLoading: (isLoading: boolean) => {
    set(() => {
      return {
        isLoading,
      };
    });
  },
  setIsSuccess: (isSuccess: boolean) => {
    set(() => {
      return {
        isSuccess,
      };
    });
  },
  setMapData: (mapData: ParticipantsByZcta[] | undefined) => {
    set(() => {
      return {
        mapData,
      };
    });
  },
  setData: (data: HhcParticipantData | undefined) => {
    set(() => {
      return {
        data,
      };
    });
  },
}));

export default useLayoutThreeStore;
